<template>
  <span>
    <span v-if="isValidDate(date) ">
      {{ moment(date).format('DD/MM/YYYY') }}
    </span>
    <span v-else>-</span>
  </span>
</template>

<script>

import moment from "moment"
export default {
  
  props: {
    date:{
      type:String,
      required:true
    }
  },

  data(){
    return{
      moment:moment
    }
  },
  methods:{
    isValidDate(d) {
      return d instanceof Date && !isNaN(d);
    }
  },
  computed:{

  },
  watch:{

  },
  components: {
   
  },
};
</script>

<style>

</style>